import React from "react";

function CircularProgressMeter({
  percent = 0,
  color = "primary",
  centerLabel,
  size = 52,
  strokeWidth = 6,
}) {
  const radius = size / 2;
  const normalizedRadius = radius - strokeWidth / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const clampedPercent = Math.max(0, Math.min(100, percent));
  const strokeDashoffset = circumference - (clampedPercent / 100) * circumference;

  return (
    <svg
      height={size}
      width={size}
      className="flex-shrink-0"
      style={{ overflow: "visible" }}
    >
      <circle
        stroke="var(--bs-border-color)"
        fill="transparent"
        strokeWidth={strokeWidth}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <circle
        className={`text-${color}`}
        stroke="currentColor"
        fill="transparent"
        strokeWidth={strokeWidth}
        strokeDasharray={`${circumference} ${circumference}`}
        strokeDashoffset={strokeDashoffset}
        strokeLinecap="round"
        r={normalizedRadius}
        cx={radius}
        cy={radius}
        transform={`rotate(-90 ${radius} ${radius})`}
        style={{ transition: "stroke-dashoffset 0.5s ease" }}
      />
      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        className={`fw-semibold text-${color}`}
        style={{ fontSize: size * 0.28 }}
      >
        {centerLabel}
      </text>
    </svg>
  );
}

export default CircularProgressMeter;